(function() {
  'use strict';

  class QuickFilters extends HTMLElement {
    constructor() {
      super();
      this.activePopout = null;
      this.documentClickHandler = this.onDocumentClick.bind(this);
      this.escHandler = this.onEsc.bind(this);
    }

    connectedCallback() {
      this.querySelectorAll('[data-quick-filter-toggle]').forEach(toggle => {
        if (toggle.dataset.quickFilterBound === 'true') return;
        toggle.dataset.quickFilterBound = 'true';
        toggle.addEventListener('click', event => this.onToggleClick(event, toggle));
      });

      this.querySelectorAll('[data-quick-filter-value]').forEach(value => {
        if (value.dataset.quickFilterBound === 'true') return;
        value.dataset.quickFilterBound = 'true';
        value.addEventListener('click', event => this.onValueClick(event, value));
      });

      this.querySelectorAll('[data-quick-filter-apply]').forEach(apply => {
        if (apply.dataset.quickFilterBound === 'true') return;
        apply.dataset.quickFilterBound = 'true';
        apply.addEventListener('click', event => this.onApplyClick(event, apply));
      });

      this.querySelectorAll('[data-quick-filter-clear]').forEach(clear => {
        if (clear.dataset.quickFilterBound === 'true') return;
        clear.dataset.quickFilterBound = 'true';
        clear.addEventListener('click', event => this.onClearClick(event, clear));
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.removeEventListener('keydown', this.escHandler);
    }

    onToggleClick(event, toggle) {
      event.stopPropagation();
      const filter = toggle.closest('[data-quick-filter]');
      const popout = filter.querySelector('[data-quick-filter-popout]');
      const isOpen = !popout.hasAttribute('hidden');

      this.closeAll();

      if (!isOpen) {
        popout.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        this.activePopout = popout;
        document.addEventListener('click', this.documentClickHandler);
        document.addEventListener('keydown', this.escHandler);
      }
    }

    onValueClick(event, value) {
      event.stopPropagation();
      const isActive = value.classList.toggle('is-active');
      value.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }

    onApplyClick(event, apply) {
      event.preventDefault();
      const filter = apply.closest('[data-quick-filter]');
      const param = filter.getAttribute('data-quick-filter-param');
      const values = filter.querySelectorAll('[data-quick-filter-value].is-active');

      const url = new URL(window.location.href);

      Array.from(url.searchParams.keys())
        .filter(key => key === param)
        .forEach(key => url.searchParams.delete(key));

      values.forEach(value => {
        url.searchParams.append(param, value.getAttribute('data-value-value'));
      });

      url.searchParams.delete('page');

      this.closeAll();
      this.applyUrl(url.toString());
    }

    onClearClick(event, clear) {
      event.preventDefault();
      const filter = clear.closest('[data-quick-filter]');
      const param = filter.getAttribute('data-quick-filter-param');
      const url = new URL(window.location.href);

      Array.from(url.searchParams.keys())
        .filter(key => key === param)
        .forEach(key => url.searchParams.delete(key));

      url.searchParams.delete('page');

      this.closeAll();
      this.applyUrl(url.toString());
    }

    applyUrl(newUrl) {
      const form = document.querySelector('[data-collection-filters-form]');
      if (form) {
        const collectionFiltersForm = form.closest('collection-filters-form');
        if (collectionFiltersForm && typeof collectionFiltersForm.submitForm === 'function') {
          collectionFiltersForm.submitForm({ type: 'quickfilter' }, newUrl);
        } else {
          window.location.href = newUrl;
        }
      } else {
        window.location.href = newUrl;
      }
    }

    closeAll() {
      this.querySelectorAll('[data-quick-filter-popout]').forEach(popout => {
        popout.setAttribute('hidden', '');
      });
      this.querySelectorAll('[data-quick-filter-toggle]').forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
      });
      this.activePopout = null;
      document.removeEventListener('click', this.documentClickHandler);
      document.removeEventListener('keydown', this.escHandler);
    }

    onDocumentClick(event) {
      if (!this.activePopout) return;
      if (this.activePopout.contains(event.target)) return;
      if (event.target.closest('[data-quick-filter-toggle]')) return;
      this.closeAll();
    }

    onEsc(event) {
      if (event.key === 'Escape') this.closeAll();
    }
  }

  if (!customElements.get('quick-filters')) {
    customElements.define('quick-filters', QuickFilters);
  }
})();
